import {ProductStoreAction} from '../store/products';
import {PromotionStoreAction} from '../store/promotions';
import {AssetStoreAction} from '../store/assets';
import {TickerStoreAction} from '../store/ticker';

const TICKER_FEED_UPDATE_INTERVAL = 5 * 60 * 1000;

export default {

    methods: {

        async populatePlayerStores() {

            this.logger.info(`- Fetching products...`);
            await this.$store.dispatch(ProductStoreAction.POPULATE_PRODUCTS, {slim: true});

            this.logger.info(`- Fetching promotions...`);
            await this.$store.dispatch(PromotionStoreAction.POPULATE_PROMOTIONS);

            this.logger.info(`- Fetching assets...`);
            await this.$store.dispatch(AssetStoreAction.LOAD_ASSETS, {slim: true});

            this.logger.info(`- Fetching feeds...`);
            await this.$store.dispatch(TickerStoreAction.POPULATE_FEEDS);
        },

        startUpdatingFeeds() {

            this.logger.info('Start updating feeds');

            this.feedUpdateInterval = window.setInterval(() => {

                this.logger.info('Refetching feeds...');
                this.$store.dispatch(TickerStoreAction.POPULATE_FEEDS);

            }, TICKER_FEED_UPDATE_INTERVAL);
        },

        stopUpdatingFeeds() {

            if (this.feedUpdateInterval) {
                window.clearInterval(this.feedUpdateInterval);
            }
        }
    }
}
